import styled from 'styled-components';

export const TableCourse = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border: 1px solid #a8cbe2;
  border-radius: 4px;
  width: 100%;

  &::-webkit-scrollbar {
    height: 6px;
  }
`;

export const TableHeader = styled.div<{
  isMobile?: boolean;
}>`
  display: flex;
  background-color: ${({ isMobile }) => (isMobile ? '#ECF4F9' : '#F5F5F5')};
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  border-bottom: ${({ isMobile }) => (isMobile ? '1px solid #A8CBE2' : 'none')};
  width: 100%;

  & > div {
    height: 60px;
    display: flex;
    align-items: center;
    padding: 8px;
    color: #161d1f;
    width: 100%;
  }

  @media (max-width: 639.5px) {
    grid-template-columns: 1fr;
    font-size: 14px;
    line-height: 20px;
    padding: 12px;
  }
`;

export const TableBody = styled.div<{
  expanded: boolean;
  isMobile: boolean;
}>`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${({ expanded }) => (expanded ? '#ECF4F9' : '#fff')};
`;

export const TableRow = styled.div<{
  expanded?: boolean;
}>`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  background-color: #ffffff;
  border-top: ${({ expanded }) =>
    expanded ? '1px solid #A8CBE2' : '1px solid #d5e5f0'};
  line-height: 20px;
  width: 100%;

  & > p,
  & > div {
    height: 60px;
    display: flex;
    align-items: center;
    padding: 8px;
    width: 100%;
  }

  & p.courseType {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 60px;
  }

  &.expanded {
    font-weight: 700;
    background-color: #ecf4f9;
    position: sticky;
    top: 0px;
  }

  @media (min-width: 992px) {
    &.expanded {
      top: 70px;
    }
  }

  @media (min-width: 830px) {
    & p.courseType {
      width: 100%;
    }
  }
`;

/* Sección estilos para subtabla */
export const ContainerSubTable = styled.div`
  width: max-content;
  padding: 0px 12px 12px 12px;
  gap: 10px;
  width: 100%;
`;

export const SubTable = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px solid #84b1cc;
  overflow-x: auto;
  width: 100%;

  &::-webkit-scrollbar {
    height: 6px;
  }

  @media (max-width: 720px) {
    overflow-x: auto;
    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #84b1cc;
      border-radius: 4px;
    }
  }
`;

// display: grid;
// grid-template-columns: 332px 142px 142px 122px 132px 224px;
// align-items: center;
// font-size: 14px;
// font-weight: 400;
// background-color: #ffffff;
// border-top: ${({ expanded }) => expanded ? '1px solid #A8CBE2' : '1px solid #d5e5f0'};
// line-height: 20px;

// & > div {
//   height: 60px;
//   display: flex;
//   align-items: center;
//   padding: 8px 16px;
// }

export const SubTableHeader = styled.div`
  display: grid;
  grid-template-columns: 152px 332px 312px 268px;
  align-items: center;
  font-weight: 700;
  font-size: 12px;
  // background-color: #e9f4fb;
  background-color: #f5f5f5;
  border-radius: 8px 8px 0px 0px;
  line-height: 16px;
  width: max-content;
  border-bottom: solid 1px #a8cbe2;

  & > div {
    height: 60px;
    display: flex;
    align-items: center;
    padding: 8px 16px;
  }
`;

export const SubTableBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const SubTableRow = styled.div`
  min-height: 56px;
  font-size: 12px;
  font-weight: 400;
  display: grid;
  grid-template-columns: 152px 332px 312px 268px;
  background-color: #ffffff;
  border-top: 1px solid #d5e5f0;
  width: max-content;

  & > div {
    height: auto;
    display: flex;
    align-items: center;
    padding: 8px 16px;
  }
`;
